import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './reducer/store';
import './index.css';
import Layout from './components/Layout';
import AppContextProvider from './contexts/AppContextProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <Provider store={store}>
    <Router>
      <AppContextProvider>
        <Layout />
      </AppContextProvider>
    </Router>
  </Provider>

);
